module.exports = __webpack_public_path__ + "static/media/5922.b72b8070.jpg";